import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { SplitHeading } from "./Reveal";

const FAQS = [
  ["How do I receive my account?", "After your payment is confirmed, OGM puts your account login on your private order page and emails you when it's ready. We may also message you on the handle you gave us."],
  ["Which platforms do you support?", "PC only. Every account in the lineup is a PC account."],
  ["How can I pay?", "Card through Stripe (instant), Apple Pay (Apple Cash to our number), PayPal (scan our QR code), crypto (BTC, ETH, USDT), Cash App ($Alex19qj), or choose 'Contact me' and we'll reach out to arrange payment. For Apple Pay, PayPal, crypto and Cash App you can upload a payment screenshot on your order page to speed things up."],
  ["How long does delivery take?", "[Add your typical delivery time here, e.g. 'within X hours of payment'.]"],
  ["Do you offer refunds or replacements?", "No refunds without reasonable issue."],
  ["How do I check my order?", "After ordering you get a private order page and an email with its link. It shows your payment status, and your account login appears there once it's delivered. Lost the link? Use 'Find my order' at the bottom of the page and we'll email it again."],
];

export const Faq = () => (
  <section id="faq" className="border-t border-white/10 bg-[#0b0b11]" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:grid-cols-12 md:px-10 md:py-32">
      <div className="md:col-span-4">
        <SplitHeading eyebrow="05 — Intel" lines={["Questions?"]} className="text-6xl md:text-8xl" />
      </div>
      <Accordion type="single" collapsible className="md:col-span-8">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={q} value={`f${i}`} className="border-white/10">
            <AccordionTrigger className="py-6 text-left text-lg font-semibold text-white hover:text-[#c084fc] hover:no-underline" data-testid={`faq-trigger-${i}`}>
              {q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-base text-slate-300">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
